export default {
  en: {
    STRIKE_PRICE_CLEAR_ALL: 'Clear All',
    STRIKE_PRICE_TIMEZONE_LABEL: 'Times shown in {zone}.',
    STRIKE_PRICE_TIMEZONE_NON_HOURLY: 'Times shown in UTC because {zone} is at {offset}.',
    STRIKE_PRICE_TIMEZONE_UNKNOWN: 'Times shown in UTC because the account timezone is not recognised.',
    STRIKE_PRICE_GRID_EMPTY: 'No strike prices configured. Click a cell and type a price.',
    STRIKE_PRICE_HOW_TO_TITLE: 'How to use this schedule:',
    STRIKE_PRICE_HOW_TO_FILL: 'To fill, select one or more cells, type the strike price, and press enter.',
    STRIKE_PRICE_HOW_TO_DELETE: 'To delete, select one or more cells and press delete.',
    STRIKE_PRICE_HOW_TO_COPY: 'You can copy cells from a spreadsheet and paste them into this table.',
  },
};
